module.exports = __webpack_public_path__ + "img/acct-img-blue.b9508d1c.svg";